import {CommonModule} from "@angular/common"
import {Component, HostListener, OnInit, signal, ChangeDetectionStrategy} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {Breakpoints} from "@common/models/constants/breakpoints"
import {SidenavComponent} from "@common/components/navigation"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-entity-responsive-sidebar",
    templateUrl: "./entity-responsive-sidebar.component.html",
    styleUrls: ["./entity-responsive-sidebar.component.scss"],
    imports: [CommonModule, MatTooltipModule, SidenavComponent],
})
export class EntityResponsiveSidebarComponent implements OnInit {
    @HostListener("window:resize", ["$event"])
    onResize(_event: Event) {
        this.$isBigScreen.set(window.innerWidth >= Breakpoints.smallScreenLimit)
    }

    readonly $isBigScreen = signal<boolean | undefined>(undefined)
    readonly $sidenavOpen = signal(false)

    ngOnInit() {
        this.$isBigScreen.set(window.innerWidth >= Breakpoints.smallScreenLimit)
    }
}
